import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { OuterService } from './outer.service';
import { GenericService } from '../generic.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(private service: GenericService, private outerService: OuterService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const expectedRoles = route.data.expectedRoles;
    const token = this.service.getToken();
    let tokenPayload: any;

    console.log('I am from guard service');

    if (token != null) {
      tokenPayload = this.jwtHelper.decodeToken(token);
    } else {
      console.log('I am logout because token is null');
      this.service.logout();
      return false;
    }

    if (!this.service.isAuthenticated()) {
      console.log('I am logout because I am not authenticated');
      this.service.logout();
      return false;
    }

    if (expectedRoles !== undefined && !expectedRoles.includes(tokenPayload.Role)) {
      this.service.error('You do not have permission to view this content!');
      return false;
    }

    return true;
  }
}
